// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = require("!!../../../../../../node_modules/css-loader/dist/cjs.js??ref--3-oneOf-0-1!../../../../../../node_modules/postcss-loader/src/index.js??ref--3-oneOf-0-2!./authorization-code-form.css?module");
if(typeof content === 'string') content = [[module.id, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var add = require("!../../../../../../node_modules/vue-style-loader/lib/addStylesClient.js").default
var update = add("759f125e", content, true, {"sourceMap":false});